import { render, staticRenderFns } from "./ContactBasic.vue?vue&type=template&id=0ed20d5f&scoped=true"
import script from "./ContactBasic.vue?vue&type=script&lang=js"
export * from "./ContactBasic.vue?vue&type=script&lang=js"
import style0 from "./ContactBasic.vue?vue&type=style&index=0&id=0ed20d5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed20d5f",
  null
  
)

export default component.exports